import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, " | ", -1 /* HOISTED */)
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = {
  key: 2,
  colspan: "5"
}
const _hoisted_6 = {
  key: 0,
  class: "edit-row"
}
const _hoisted_7 = ["colspan"]
const _hoisted_8 = { class: "col-12 row" }
const _hoisted_9 = { class: "form-group col-12 col-lg-6" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "equipment-name" }, " Equipment Name ", -1 /* HOISTED */)
const _hoisted_11 = { class: "form-group col-12 col-lg-6" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "provider-name" }, " Provider Name ", -1 /* HOISTED */)
const _hoisted_13 = { class: "col-12 row" }
const _hoisted_14 = { class: "form-group col-12 col-lg-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "model-no" }, " Model Number ", -1 /* HOISTED */)
const _hoisted_16 = { class: "form-group col-12 col-lg-6" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "serial-no" }, " Serial Number ", -1 /* HOISTED */)
const _hoisted_18 = {
  key: 0,
  class: "d-flex justify-content-center pt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyTextHandler = _resolveComponent("EmptyTextHandler")!
  const _component_TablePrompt = _resolveComponent("TablePrompt")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", {
      class: _normalizeClass(_ctx.isDmeNeededFormOpen || _ctx.isDeleteRequested ? 'edit-row' : '')
    }, [
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.dme.dmeName
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.dme.provider
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.dme.serialNo
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.dme.modelNo
        }, null, 8 /* PROPS */, ["text"])
      ]),
      (!_ctx.isDmeNeededFormOpen && !_ctx.isDeleteRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_1, [
            _createElementVNode("button", {
              type: "button",
              class: "btn table-btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDmeNeededForm(true)))
            }, "Edit"),
            _hoisted_2,
            _createElementVNode("button", {
              type: "button",
              class: "btn table-btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.requestDeleteContact()))
            }, "Delete")
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.isDmeNeededFormOpen)
        ? (_openBlock(), _createElementBlock("td", _hoisted_3, [
            _createElementVNode("i", _hoisted_4, _toDisplayString(_ctx.isEditRequested ? "Editing In Progress" : "View In Progress"), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.isDeleteRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_5, [
            _createVNode(_component_TablePrompt, {
              "ok-text": "delete",
              name: "Delete",
              "is-in-progress": _ctx.isDeleteInProgress,
              ok: _ctx.deleteDmeNeeded(_ctx.dme.id),
              cancel: _ctx.cancelDeleteContact
            }, null, 8 /* PROPS */, ["is-in-progress", "ok", "cancel"])
          ]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    _createCommentVNode(" Form Editing "),
    (_ctx.isDmeNeededFormOpen)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
          _createElementVNode("td", {
            colspan: _ctx.columns,
            class: "p-3"
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("p", null, [
                  _createVNode(_component_EmptyTextHandler, {
                    text: _ctx.dme.dmeName
                  }, null, 8 /* PROPS */, ["text"])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dme.provider) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.dme.provider]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dme.modelNo) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.dme.modelNo]
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dme.serialNo) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.dme.serialNo]
                ])
              ])
            ]),
            (!_ctx.isSaving)
              ? (_openBlock(), _createElementBlock("footer", _hoisted_18, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary me-2 mb-2",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.saveDme(_ctx.dme.id)))
                  }, "Save"),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-primary mb-2",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closeDmeNeededForm()))
                  }, "Cancel")
                ]))
              : _createCommentVNode("v-if", true)
          ], 8 /* PROPS */, _hoisted_7)
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}